import "./Button.scss";

function Button({ name, className, onClick }) {
  return (
    <button
      className={`w-100 button ${className}`}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {name}
    </button>
  );
}

export default Button;
